import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Line from './pages/Line';
import Map3D from './pages/Map3D';
import Announcements from './pages/Announcements';
import Diplomacy from './pages/Diplomacy';
import Gallery from './pages/Gallery';
import Join from './pages/Join';
import Downloads from './pages/Downloads';
import ImageHost from './pages/ImageHost';
import Apply from './pages/Apply';
import Account from './pages/Account';
import Admin from './pages/Admin';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<Home />} />
              <Route path="/line" element={<Line />} />
              <Route path="/map" element={<Map3D />} />
              <Route path="/announcement" element={<Announcements />} />
              <Route path="/diplomacy" element={<Diplomacy />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/join" element={<Join />} />
              <Route path="/download" element={<Downloads />} />
              <Route path="/image" element={<ImageHost />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
